import React from "react";
import "./AuditStepper.css";

type AuditStepperProps = {
  /** Which step is currently active (highlighted blue). */
  activeStep: 1 | 2;
  /** Optional caption shown below the steps, e.g. "STEP 2: RESULT". */
  label?: string;
};

/**
 * Two-step progress indicator shared by the audit flow.
 * - Step 1 active → "STEP 1: DETAILS" (the form view)
 * - Step 2 active → "STEP 2: RESULT" (the report view, after the loader hits 100%)
 */
const AuditStepper: React.FC<AuditStepperProps> = ({ activeStep, label }) => {
  const stepClass = (step: 1 | 2) =>
    `audit-stepper__step ${
      activeStep === step
        ? "audit-stepper__step--active"
        : "audit-stepper__step--completed"
    }`;

  return (
    <div className="audit-stepper">
      <div className="audit-stepper__row">
        <span className={stepClass(1)}>1</span>
        <span className="audit-stepper__line" />
        <span className={stepClass(2)}>2</span>
      </div>

      {label ? <p className="audit-stepper__label">{label}</p> : null}
    </div>
  );
};

export default AuditStepper;
